// Price guide content — genuine Norwegian content for 10 treatments.

export const PRICE_GUIDES = {
  "botox": {
    treatment: "Botox / Rynkebehandling",
    category: "Estetikk & Kosmetikk",
    shortLabel: "Botox",
    ranges: {
      typical: "1 500 – 4 000 kr",
      Oslo: { low: 1500, typical: 2500, high: 4000 },
      Drammen: { low: 1400, typical: 2300, high: 3600 },
      "Norge (snitt)": { low: 1500, typical: 2400, high: 3800 },
    },
    factors: [
      "Antall områder som behandles (panne, glabella, øyenkrok)",
      "Mengde produkt (enheter) som brukes",
      "Behandlerens erfaring og spesialisering",
      "Klinikkens beliggenhet (sentrum vs. utenfor)",
    ],
    included: "Konsultasjon, selve behandlingen og en gratis etterkontroll etter 2 uker inngår vanligvis.",
    hidden: "Vær oppmerksom på eventuelle konsultasjonsgebyrer, ekstra områder og oppfølgende justeringer som kan komme i tillegg.",
    faqs: [
      { q: "Hvor ofte må jeg ta botox?", a: "Effekten varer typisk 3–4 måneder. De fleste gjentar behandlingen 2–3 ganger i året." },
      { q: "Er botox trygt?", a: "Ja, når det utføres av en godkjent helsepersonell. I Norge kan kun leger, tannleger og sykepleiere (med rekvisisjon) injisere botulinumtoksin." },
      { q: "Kan jeg trene etter botox?", a: "Unngå intens fysisk aktivitet de første 24 timene for å minimere risiko for at produktet migrerer." },
    ],
  },
  "fillers": {
    treatment: "Fillers / Leppeforming",
    category: "Estetikk & Kosmetikk",
    shortLabel: "Fillers",
    ranges: {
      typical: "2 000 – 5 000 kr",
      Oslo: { low: 2500, typical: 3500, high: 5000 },
      Drammen: { low: 2200, typical: 3200, high: 4500 },
      "Norge (snitt)": { low: 2300, typical: 3400, high: 4800 },
    },
    factors: ["Mengde produkt (1 ml vs. 2 ml)", "Produktmerket (Juvederm, Restylane, Teosyal)", "Behandlingsområde (lepper, kinn, nasolabialfurer)", "Behandlerens erfaring"],
    included: "Konsultasjon, merkebaserte hyaluronsyre-produkter, behandling og en etterkontroll.",
    hidden: "Oppløsende enzym (hyaluronidase) ved bivirkninger kan koste ekstra. Ikke alle klinikker inkluderer dette.",
    faqs: [
      { q: "Hvor lenge varer fillers?", a: "Avhengig av produkt og område: 6–18 måneder." },
      { q: "Er fillers smertefullt?", a: "Moderne fillers inneholder lidokain, så det er godt tolerert. Bedøvelseskrem brukes også." },
    ],
  },
  "hartransplantasjon": {
    treatment: "Hårtransplantasjon",
    category: "Hår & Hodebunn",
    shortLabel: "Hårtransplantasjon",
    ranges: {
      typical: "25 000 – 60 000 kr",
      Oslo: { low: 30000, typical: 45000, high: 70000 },
      Drammen: { low: 28000, typical: 40000, high: 60000 },
      "Norge (snitt)": { low: 29000, typical: 43000, high: 65000 },
    },
    factors: [
      "Antall grafts (500–5000 stk.)",
      "Teknikk (FUE vs. DHI vs. Sapphire FUE)",
      "Klinikkens renommé og erfaring",
      "Om norsk eller utenlandsk klinikk (Tyrkia koster mindre, men reise og oppfølging må vurderes)",
    ],
    included: "Konsultasjon, blodprøver, selve operasjonen, medisiner og 1–2 kontroller inngår vanligvis i pakken.",
    hidden: "PRP-behandlinger, spesialsjampo og reiseutgifter ved utenlandsk klinikk kommer ofte i tillegg.",
    faqs: [
      { q: "Gir hårtransplantasjon permanent resultat?", a: "Transplanterte hår er resistente mot DHT og varer livet ut, men gjenværende hår kan fortsette å tynnes." },
      { q: "Hvor lang er hentetiden?", a: "Du kan returnere til jobb etter 3–7 dager. Fullt resultat sees etter 9–12 måneder." },
    ],
  },
  "tannbleking": {
    treatment: "Tannbleking",
    category: "Tannhelse & Smil",
    shortLabel: "Tannbleking",
    ranges: {
      typical: "2 500 – 6 000 kr",
      Oslo: { low: 3000, typical: 4500, high: 6500 },
      Drammen: { low: 2500, typical: 3800, high: 5500 },
      "Norge (snitt)": { low: 2700, typical: 4200, high: 6000 },
    },
    factors: ["Metode (hjemmeblekking vs. klinikkblekking vs. laser)", "Tannens utgangspunkt (misfarging fra kaffe, vin, røyk)", "Antall økter"],
    included: "Undersøkelse, profesjonell rens, bleking og oppfølging.",
    hidden: "Egen sensitivitetsgel og etter-kontroll kan koste ekstra.",
    faqs: [
      { q: "Er tannbleking trygt?", a: "Ja, når det utføres av tannlege. Hjemmekit uten tilsyn kan skade emaljen." },
      { q: "Hvor lenge varer resultatet?", a: "Mellom 1–3 år avhengig av kosthold og vedlikehold." },
    ],
  },
  "fysioterapi": {
    treatment: "Fysioterapi (privat)",
    category: "Fysioterapi & Kiropraktor",
    shortLabel: "Privat fysioterapi",
    ranges: {
      typical: "800 – 1 500 kr per time",
      Oslo: { low: 850, typical: 1100, high: 1500 },
      Drammen: { low: 800, typical: 1000, high: 1300 },
      "Norge (snitt)": { low: 800, typical: 1100, high: 1500 },
    },
    factors: ["Spesialisering (idrett, manuell, rehabilitering)", "Erfaring og tittel", "Sentrumsbeliggenhet"],
    included: "30–60 minutter konsultasjon, undersøkelse og behandling. Mange tilbyr også oppfølging via video.",
    hidden: "Treningsprogram, ekstra kontroller eller utstyr kan koste ekstra. Avbestilling sent kan medføre gebyr.",
    faqs: [
      { q: "Får jeg refusjon?", a: "Ikke uten henvisning og driftstilskudd. Privat fysioterapi er som regel ikke dekket av Helfo, men noen forsikringer dekker." },
      { q: "Hvor fort får jeg time?", a: "Privat: typisk innen 1–2 uker. Offentlig: 1–6 måneders ventetid." },
    ],
  },
  "oyenlaser": {
    treatment: "Øyenlaser (LASIK/LASEK)",
    category: "Øye & Syn",
    shortLabel: "Øyenlaser",
    ranges: {
      typical: "15 000 – 25 000 kr (per øye)",
      Oslo: { low: 15000, typical: 20000, high: 28000 },
      Drammen: { low: 14000, typical: 19000, high: 25000 },
      "Norge (snitt)": { low: 14500, typical: 19500, high: 26500 },
    },
    factors: ["Teknologi (LASIK, LASEK, ReLEx SMILE)", "Synsfeilens styrke og kompleksitet", "Garantipakke og oppfølging"],
    included: "Forundersøkelse, selve operasjonen, øyedråper og 1 års oppfølging i de fleste pakker.",
    hidden: "Ekstra justeringer utover garantiperioden kan koste 5 000–15 000 kr.",
    faqs: [
      { q: "Er øyenlaser permanent?", a: "Ja, men aldersrelaterte synsendringer kan fortsatt oppstå etter 40-årsalderen." },
      { q: "Når kan jeg jobbe igjen?", a: "LASIK: 1–2 dager. LASEK: 5–7 dager." },
    ],
  },
  "laserbehandling": {
    treatment: "Laserbehandling (hud)",
    category: "Hud & Laser",
    shortLabel: "Laserbehandling",
    ranges: {
      typical: "2 000 – 8 000 kr per økt",
      Oslo: { low: 2000, typical: 4500, high: 9000 },
      Drammen: { low: 1800, typical: 4000, high: 8000 },
      "Norge (snitt)": { low: 1900, typical: 4200, high: 8500 },
    },
    factors: ["Laser-type (IPL, Fraxel, CO2, Nd:YAG)", "Størrelse på område", "Antall økter (ofte 3–6)"],
    included: "Konsultasjon, patch-test og selve behandlingen.",
    hidden: "Nummerkrem og etter-pleiekrem kan tilkomme.",
    faqs: [{ q: "Hvor mange økter trenger jeg?", a: "Avhengig av behandling — typisk 3–6 økter med 4–6 ukers mellomrom." }],
  },
  "kiropraktor": {
    treatment: "Kiropraktor",
    category: "Fysisk Helse",
    shortLabel: "Kiropraktor",
    ranges: {
      typical: "600 – 1 100 kr per time",
      Oslo: { low: 700, typical: 900, high: 1200 },
      Drammen: { low: 600, typical: 800, high: 1050 },
      "Norge (snitt)": { low: 650, typical: 850, high: 1100 },
    },
    factors: ["Første konsultasjon (dyrere) vs. oppfølging", "Kompleksitet i plagen"],
    included: "Undersøkelse og behandling.",
    hidden: "Ekstra røntgen eller MR henvises videre og betales separat.",
    faqs: [{ q: "Får jeg refusjon hos kiropraktor?", a: "Ja, med henvisning kan du få refusjon for inntil 14 behandlinger per år." }],
  },
  "fysioterapi": {
    treatment: "Fysioterapi (privat)",
    category: "Fysisk Helse",
    shortLabel: "Privat fysioterapi",
    ranges: {
      typical: "700 – 1 200 kr per time",
      Oslo: { low: 800, typical: 1000, high: 1300 },
      Drammen: { low: 700, typical: 900, high: 1100 },
      "Norge (snitt)": { low: 750, typical: 950, high: 1200 },
    },
    factors: ["Varighet på time (30, 45, 60 min)", "Spesialisering (manuell, idretts)", "Om det kreves henvisning"],
    included: "Undersøkelse, behandling og øvelser.",
    hidden: "Bandasjer, såler eller hjemmeutstyr kommer i tillegg.",
    faqs: [{ q: "Må jeg ha henvisning?", a: "Nei, du kan oppsøke privat fysioterapeut direkte — men henvisning kreves for refusjon." }],
  },
  "aknebehandling": {
    treatment: "Aknebehandling",
    category: "Hud & Laser",
    shortLabel: "Aknebehandling",
    ranges: {
      typical: "1 500 – 5 000 kr per økt",
      Oslo: { low: 1500, typical: 3000, high: 6000 },
      Drammen: { low: 1400, typical: 2700, high: 5000 },
      "Norge (snitt)": { low: 1450, typical: 2850, high: 5500 },
    },
    factors: ["Behandlingsform (peel, laser, micro-needling)", "Alvorlighetsgrad", "Antall økter"],
    included: "Hudanalyse og selve behandlingen.",
    hidden: "Apotek-hudpleie anbefalt mellom økter.",
    faqs: [{ q: "Kan akne behandles permanent?", a: "Aktive utbrudd kan kontrolleres, men arr krever separate behandlinger som laser eller micro-needling." }],
  },
};

export const priceGuideList = () => Object.entries(PRICE_GUIDES).map(([slug, g]) => ({ slug, ...g }));
